export default __webpack_public_path__ + "static/media/Santen.fd75def3.png";